import { createContext } from 'react';

const ReportDateContext = createContext({});

export default ReportDateContext;
